<template>
	<popupLayout :popupClass="'modal-lg'">
		<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
		<div class="bootbox-body">
			<div class="row form-group">
				<div class="col-md-12">
					<table class="table table-no-more table-bordered table-striped mb-none">
						<thead>
							<tr>
								<th class="text-center" width="10%">房棟</th>
								<th class="text-center" width="5%">樓層</th>
								<th class="text-center" width="10%">打掃點</th>
								<th class="text-center" width="12%">打掃結果</th>
								<th class="text-center" width="10%">初掃幹部</th>
								<th class="text-center" width="12%">複掃結果</th>
								<th class="text-center" width="10%">複掃幹部</th>
								<th class="text-center" width="16%">檢查/複查時間</th>
								<th class="text-center" width="15%">打掃負責寢室</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(his, key) in hisList" :key="key">
								<td data-title="房棟" class="text-center">{{his.house}}</td>
								<td data-title="樓層" class="text-center">{{his.flood}}</td>
								<td data-title="打掃點" class="text-center">{{his.cleanLocation}}</td>
								<td data-title="打掃結果" class="text-center">
									{{his.situation}}
									<br/>
									<a :href="`/upload/${his.proofFile}`" target="_blank" v-if="his.proofFile">打掃結果照片</a>
								</td>
								<td data-title="初掃幹部" class="text-center">{{his.reviewerName}}</td>
								<td data-title="複掃結果" class="text-center">
									{{his.agResult}}
									<br/>
									<a :href="`/upload/${his.agProofFile}`" target="_blank" v-if="his.agProofFile">複掃結果照片</a>
								</td>
								<td data-title="複掃幹部" class="text-center">{{his.agReviewerName}}</td>
								<td data-title="檢查/複查時間" class="text-center">
									<span>{{`(一)${his.resultDateStr}`}}</span>
									<span v-if="his.agResultDateStr">{{`(二)${his.agResultDateStr}`}}</span>
								</td>
								<td data-title="打掃負責寢室" class="text-center">{{his.staffBedFloodRoom}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="row">
				<div class="col-md-offset-5 col-md-2">
					<a class="btn btn-danger btn-block" @click="closePopup">關閉</a>
				</div>
			</div>
		</div>
	</popupLayout>
</template>
<script>
import popupLayout from '@/components/popup/popupLayout';
export default {
	components:{
		popupLayout
	},
	props:['hisList'],
	methods:{
		closePopup() {
			this.$parent.showHisPopupControl(false);
		},
	}
}
</script>
<style scoped>
@media only screen and (max-device-height : 667px){
	.bootbox-body{
		max-height:480px;
		overflow-y:auto;
	}
}
@media only screen and (max-device-height : 736px) {
	.bootbox-body{
		max-height:600px;
		overflow-y:auto;
	}
}
</style>
